export default defineNuxtPlugin(() => {
  onNuxtReady(async () => {
    useHead({
      bodyAttrs: {
        class: 'page-ready',
      },
    })
  })
})
